module.exports = __webpack_public_path__ + "static/media/laptop-alt-2-svgrepo-com.947f971e.svg";